import { FC, useCallback, useMemo } from 'react'
import { useGoogleMapLogger } from 'hooks/logger/useGoogleMapLogger'

type Props = {
  lat: number
  lng: number
}

const SpaceAddressMapComponent: FC<Props> = ({ lat, lng }) => {
  const { logGoogleMapUsage } = useGoogleMapLogger()

  const onLoadGoogleMap = useCallback(() => {
    if (lat === undefined || lng === undefined) return
    logGoogleMapUsage({
      timestamp: new Date().toISOString(),
      screen: window.location.pathname,
      env: process.env.SENTRY_ENVIRONMENT || 'staging',
      platform: 'web',
      action_type: 'load_map',
      api_sku: 'iframe map',
      latitude: lat,
      longitude: lng,
      user_input_text: '',
    })
  }, [logGoogleMapUsage, lat, lng])

  const iframeSrc = useMemo(() => {
    const apiKey = process.env.GOOGLE_MAP_KEY || ''
    const center = `${lat},${lng}`
    const zoom = 15
    const mode = 'place'

    return `https://www.google.com/maps/embed/v1/${mode}?key=${apiKey}&q=${center}&zoom=${zoom}`
  }, [lat, lng])

  return (
    <iframe
      width="100%"
      height="240"
      style={{
        border: 0,
        borderRadius: 8,
      }}
      referrerPolicy="no-referrer-when-downgrade"
      src={iframeSrc}
      allowFullScreen
      onLoad={onLoadGoogleMap}
      title="Google Maps"
    />
  )
}

export default SpaceAddressMapComponent
